// extracted by mini-css-extract-plugin
export var label = "_5h-1";
export var reminder = "_5h-0";